import { useMemo } from 'react'
import { HStack, Stack, Switch, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormAutoComplete from 'components/tools/CustomForm/commonComponents/CustomFormAutoComplete'
import { FormItem } from 'components'

type ValidationsProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function DateValidators({ formMethods }: ValidationsProps) {
  const currentWeekDays: string[] = formMethods.watch('validation.date_must_be_this_week_days') || []

  const availableWeekDays = useMemo(() => {
    return ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'].filter((weekDay) => {
      return !currentWeekDays.includes(weekDay)
    })
  }, [currentWeekDays])

  const handleOnSelect = (value: string) => {
    formMethods.setValue('validation.date_must_be_this_week_days', [...currentWeekDays, value])
  }

  const handleOnRemove = (removedValue: string) => {
    const updatedWeekDays = currentWeekDays.filter((weekDay) => weekDay !== removedValue)
    formMethods.setValue('validation.date_must_be_this_week_days', updatedWeekDays)
  }

  return (
    <Stack>
      <FormItem label="A data deve ser posterior a atual">
        <Controller
          name="validation.date_must_be_later"
          control={formMethods.control}
          render={({ field }) => (
            <Switch isChecked={field.value ?? false} onChange={(e) => field.onChange(e.target.checked)} />
          )}
        />
      </FormItem>

      <FormItem label="A data deve ser anterior a atual">
        <Controller
          name="validation.date_must_be_previous"
          control={formMethods.control}
          render={({ field }) => (
            <Switch isChecked={field.value ?? false} onChange={(e) => field.onChange(e.target.checked)} />
          )}
        />
      </FormItem>

      <FormItem label="Dias da semana permitidos">
        <CustomFormAutoComplete options={availableWeekDays} onSelect={handleOnSelect} />

        <HStack mt={2} flexWrap="wrap">
          {currentWeekDays.map((extension) => (
            <Tag variant="filter-tags" colorScheme="primary" key={extension}>
              <TagLabel>{extension}</TagLabel>
              <TagCloseButton onClick={() => handleOnRemove(extension)} />
            </Tag>
          ))}
        </HStack>
      </FormItem>
    </Stack>
  )
}
